export const TENANT_IDS = {
  ADVANCED_TURF_SOLUTIONS: "856e3cfe-6970-419d-922e-880be76c1e83",
  AES_DRILLING: "b3f81113-a782-4d70-b28f-ef6fe58992e3",
  AFTON: "b1d3f8e6-41a6-4bb5-a4c4-ad176b02f595",
  ALLEGIANT_AIR: "e555edcc-1768-41b0-b845-9255e1a8bd0d",
  ALTANA: "259cecf3-f55f-4c9f-9c68-dcc39eeb3381",
  ALTEC_INDUSTRIES: "311509f7-1829-4d8c-9025-f5d206b3d9fd",
  AMAZON: "6a92e397-bb74-44ed-afee-f84c7821f40e",
  ARCHAEA_ENERGY: "a9f91bc0-ccf2-4e2c-beb4-e6d5f3bd5482",
  ASH_GROVE_CEMENT_COMPANY: "f890510b-d61e-486e-accf-fc92ee64850c", // churned
  ASPIRUS: "25f2d344-29fe-46af-bfa4-522b05b77f68",
  ASMARK: "77cfac93-c2ff-48c8-ac6f-386558cc9cd2",
  ATLA_EQUIPMENT_GROUP: "5e2feb31-d9e8-4ffa-ba6c-78c044eaefbb",
  BD: "ddb06fbf-ebe6-4343-a26f-233937f1ad98",
  BD_FRANKLIN_LAKES: "3dbb905f-a368-40de-9954-6b72097c2844",
  BAILLIE_TENANT_ID: "d73d783b-cefb-4e29-87a9-63946aada20b",
  BASF: "046a181c-4f70-4998-90d1-da5138cbbd8b",
  BLACKSTONE_ADVANCED_TECHNOLOGIES: "689a0293-1d08-49e0-8b30-18937075f579",
  BUCKEYE_PARTNERS: "8a2242e0-7984-453b-8d81-e7d3cd7e533a",
  BUNZL: "4d5c7f11-fa2a-48a4-8110-d52dccfc3ecc",
  COMPLY_AUTO: "30d7f670-c82d-46d7-b9e8-1cf83d328fc6", // churned partner tenant
  CS_CUPA_TRACKING: "5f75ccea-d8f4-48b3-b6ce-5559047f742a",
  CSX: "611a61ca-a20e-4f48-a44c-3d78e65f87b0",
  CUB: "615a8459-4439-4282-81ba-9817c2fa9380",
  DEVON_ENERGY: "efa11250-9849-4884-ae2d-b71c6985f0bc",
  DGO: "7c101ded-1e19-400d-a3ec-a21929460764",
  DOMINION_ENERGY: "a662b62d-1468-47f7-862d-17beb8bfb6c6",
  DOMINION_RENEWABLES: "9cbc8605-3b0b-4560-abc6-08c8c0a22eb1",
  DOMINOS: "6d0fd250-6210-4468-8759-2dd0eefe41c4",
  DUKE_ENERGY: "2f4211bd-510e-4475-bac9-5dbcc94e60d1",
  ENBRIDGE: "677649b6-f657-4f00-8585-e7e9c2bf699c", // churned
  EVERGY: "75e73d9a-2cd7-4ddd-96f9-2fd526f26bb4",
  FERGUSON: "723dbe12-4a0b-4974-867e-78bb0baa7547",
  FLINT_GROUP: "68a6b7e2-a337-478e-ae2f-332f23434528",
  FORMOSA_PLASTICS: "388c9c78-9985-4553-a5b6-d3e3b40233dc",
  GARLAND_POWER_AND_LIGHT: "52ac8888-b9c3-440d-9da0-ddce9d54147d",
  GE_AEROSPACE_TENANT_ID: "49403623-dba5-487f-861a-57d9be4344a3",
  GLOBAL_PARTNERS: "38703f23-fd81-4544-9044-f804adaf58a1",
  GRAINGER: "2eb0a18e-66b4-4c3f-a3cc-bf88cf65b563",
  GREENLEAF_POWER: "0753d2e7-089c-4c32-9886-65655e6969c3",
  HALLIBURTON: "0b322147-3f77-4567-8b6a-98f84a84da5b",
  HARBOR_FREIGHT: "06c4b5ec-a081-40ae-b740-6af237fe097f",
  HARVEST_MIDSTREAM: "cf9a3218-9200-49dd-b584-437537e41822",
  HENKEL: "52b7cb81-b56d-46fb-9fa6-7f3fbc1eee1a",
  HENRY_SCHEIN: "155a4f46-2e13-4810-bf59-b74dd3b0777d",
  HEXION: "534987e8-fd81-41ae-8f3b-e405d64d87b9",
  HISCO: "e5d5e8d1-0c5c-4113-a1c2-ee33cd03dd98",
  IACX_ENERGY: "711cfe62-5a29-4856-87d9-408795b6af6f",
  KINDER_MORGAN: "8b75622f-0448-4c61-b9ed-cb22d61c8cc1",
  KNAUF: "29659038-79d4-4484-8a49-551e6522e832",
  LKQ: "d2981932-b600-4534-9c26-07f22a73fc0a",
  LUMEN: "7e2bbbeb-4d64-4734-ac24-e709e2aca5a9",
  MAYO_CLINIC: "8424b371-88c4-4316-a548-772682ff927c",
  MERSEN: "f120042f-cd9a-49e1-bdc6-c891cb73af94",
  NATIONAL_GRID_RENEWABLES: "ecb9ac93-6843-4907-b0c6-141fba655e0c",
  NGL_ENERGY_PARTNERS: "a978f00f-3f17-437a-acbf-68e6d58b6c7b",
  NUTRIEN_AG: "3fb4cfc3-01dd-471f-b2aa-92cdac25c461",
  OCCIDENTAL_PETROLEUM: "e19fee38-1b4b-49c9-93ea-6a2d9c609574",
  PETRO_STAR: "8a64e9d0-e4a8-4a52-b4ae-d4bdec666d04",
  PICK_YOUR_PART: "27d0c893-948c-4502-a898-268a5fb041b3",
  PHILIPS_HEALTHCARE: "1bbc2038-8915-4be8-8f21-3377d03ec9fb",
  PHOENIX_CHILDREN_S_HOSPITAL: "3f48ae6d-4ee7-4be6-a920-e90005883e68",
  PNW_METAL: "f4a7d9cc-912a-4edf-ab9a-544cb0f36712",
  QTS_DATA_CENTERS: "776b76f6-7ef5-4034-b5c4-84d719fbf46c",
  REVLON: "f4f1404a-0417-4de8-b815-804def06ccf7",
  RYDER: "f652797c-fe1b-455f-8fc4-5bcc224f653a",
  SELECT_WATER_SOLUTIONS: "aaa5dbaa-3908-4722-adb2-c1d121e53fa7",
  SHELL: "a6985c09-41c8-43c4-8be5-04ecda7cdd90",
  SOUTH_SIDE_LANDFILL: "7884e574-0bf6-40bb-8521-98c4ec3af4b0",
  STOLTHAVEN: "4285ef22-6b1f-4430-be42-f09d79a96c26",
  SUGAR_CANE_GROWERS_COOPERATIVE_OF_FL: "2f8045c6-9f48-419d-ac8f-e86bc31d7983",
  TESLA: "f26f0628-f0d3-499a-9fb2-093b2780c2de",
  TOPBUILD: "de1881a2-92e1-4b23-80eb-a3f895f520f5",
  T_MOBILE: "c1960fd4-6bca-40e8-99cc-e744745016fd",
  UNFI: "095e1fe8-c800-4ef5-a794-7e396f500351",
  UNIVAR: "12be5e4c-2544-440b-8d63-eab09c6665e0",
  UPS: "92ad662e-56a5-47ff-ba5f-abe2e29734a7",
  WESTLAKE: "c248cc8e-6722-4c77-96bb-fa88b127eefe",
  WHITE_CAP: "42461489-34c5-44c3-8265-789deac80bd3",
  WSI: "e70940ce-d33f-4c45-a136-c8d4cfaec328",
} as const;

/**
 * Tenant IDs that are excluded from Tier II reporting.
 * These tenants use different reporting systems or have special requirements.
 */
export const nonTierIITenantsIds: string[] = [
  TENANT_IDS.ALLEGIANT_AIR,
  TENANT_IDS.ALTEC_INDUSTRIES,
  TENANT_IDS.BD,
  TENANT_IDS.BD_FRANKLIN_LAKES,
  TENANT_IDS.BLACKSTONE_ADVANCED_TECHNOLOGIES,
  TENANT_IDS.CS_CUPA_TRACKING,
  TENANT_IDS.CUB,
  TENANT_IDS.GARLAND_POWER_AND_LIGHT,
  TENANT_IDS.GREENLEAF_POWER,
  TENANT_IDS.HARVEST_MIDSTREAM,
  TENANT_IDS.IACX_ENERGY,
  TENANT_IDS.MAYO_CLINIC,
  TENANT_IDS.MERSEN,
  TENANT_IDS.NATIONAL_GRID_RENEWABLES,
  TENANT_IDS.PETRO_STAR,
  TENANT_IDS.PHILIPS_HEALTHCARE,
  TENANT_IDS.PHOENIX_CHILDREN_S_HOSPITAL,
  TENANT_IDS.PNW_METAL,
  TENANT_IDS.SOUTH_SIDE_LANDFILL,
  TENANT_IDS.SUGAR_CANE_GROWERS_COOPERATIVE_OF_FL,
];

/**
 * Tenant IDs that have large waste volumes and require optimized or limited queries.
 *
 * Waste Tag overview filtering disable:
 * - apps/oak/src/routes/Customer/Waste/Overview/OverviewGlobalFilters.tsx
 *
 * Optimized queries:
 * - packages/encamp-shared/src/customQueries/wasteOverviewQuery.ts
 * - apps/api/src/resolvers/waste/processedManifests.ts
 */
export const largeWasteTenantsIds: string[] = [TENANT_IDS.AMAZON, TENANT_IDS.UPS];
